module.exports = __webpack_public_path__ + "img/fi-3867499.aa8a480e.svg";